import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Noticing the longing without panicking",
    opening: localizedGenderNode(
      [
      "Today I don’t try to erase longing. I notice it — and I stay.",
      "I pause with myself."
    ],
      [
      "Today I don’t try to erase longing. I notice it — and I stay.",
      "I pause with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One slow breath.",
      "I say quietly inside: “This is longing. It’s not a command.”"
    ],
      [
      "One slow breath.",
      "I say quietly inside: “This is longing. It’s not a command.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nI ask myself:\nWhat do I feel right now when the longing appears? (one or two words)",
      "I ask myself:\nWhere in my body do I feel it?",
      "If I’m willing — I let the longing be here for 60 seconds, without checking, without sending, without escaping. Just noticing.\nWhat happened after that minute?"
    ],
      [
      "Writing\nI ask myself:\nWhat do I feel right now when the longing appears? (one or two words)",
      "I ask myself:\nWhere in my body do I feel it?",
      "If I’m willing — I let the longing be here for 60 seconds, without checking, without sending, without escaping. Just noticing.\nWhat happened after that minute?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Longing can be present — and I still stay with myself."
    ],
      [
      "Closing",
      "Longing can be present — and I still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The urge to connect (and why it really appears)",
    opening: localizedGenderNode(
      [
      "Today I learn to pause an urge without fighting it.",
      "I pause with myself."
    ],
      [
      "Today I learn to pause an urge without fighting it.",
      "I pause with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nI ask myself:\nWhich urge shows up today? (to send / to check / to look)",
      "I ask myself:\nWhat am I trying to soothe through this urge?",
      "🔹 90-Second Protocol (from today onward)\nWhen an urge appears:\n1. Three slow breaths\n2. Notice the body\n3. One sentence inside: “This is an urge. It will pass.”\nThen choose one small alternative action.\nWhich alternative action do I choose today?"
    ],
      [
      "Writing\nI ask myself:\nWhich urge shows up today? (to send / to check / to look)",
      "I ask myself:\nWhat am I trying to soothe through this urge?",
      "🔹 90-Second Protocol (from today onward)\nWhen an urge appears:\n1. Three slow breaths\n2. Notice the body\n3. One sentence inside: “This is an urge. It will pass.”\nThen choose one small alternative action.\nWhich alternative action do I choose today?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t have to act for the urge to calm down."
    ],
      [
      "Closing",
      "I don’t have to act for the urge to calm down."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Story vs. fact",
    opening: localizedGenderNode(
      [
      "Today I separate what happened from what my mind tells me."
    ],
      [
      "Today I separate what happened from what my mind tells me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat is the bare fact that happened? (no interpretation)",
      "What story does my mind build around it?",
      "What one gentle truth can I choose today instead of the story?"
    ],
      [
      "Writing\nWhat is the bare fact that happened? (no interpretation)",
      "What story does my mind build around it?",
      "What one gentle truth can I choose today instead of the story?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Not every thought is truth. Some are just pain asking for attention."
    ],
      [
      "Closing",
      "Not every thought is truth. Some are just pain asking for attention."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The wave",
    opening: localizedGenderNode(
      [
      "Longing is a wave. A wave passes."
    ],
      [
      "Longing is a wave. A wave passes."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat does the wave look like for me? When does it arrive?",
      "What helps me hold for 10 minutes without a harmful action?",
      "What short sentence do I say to myself in the middle of a wave?"
    ],
      [
      "Writing\nWhat does the wave look like for me? When does it arrive?",
      "What helps me hold for 10 minutes without a harmful action?",
      "What short sentence do I say to myself in the middle of a wave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I am not measured by a wave."
    ],
      [
      "Closing",
      "I am not measured by a wave."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The blaming voice",
    opening: localizedGenderNode(
      [
      "Today I replace self-attack with a tone that holds me."
    ],
      [
      "Today I replace self-attack with a tone that holds me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat is the blaming sentence that repeats?",
      "How would I speak to a friend in my place?",
      "How does that same sentence sound in a softer version?"
    ],
      [
      "Writing\nWhat is the blaming sentence that repeats?",
      "How would I speak to a friend in my place?",
      "How does that same sentence sound in a softer version?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Responsibility without compassion does not heal."
    ],
      [
      "Closing",
      "Responsibility without compassion does not heal."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "What I truly miss",
    opening: localizedGenderNode(
      [
      "Today I break longing into parts."
    ],
      [
      "Today I break longing into parts."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat do I miss: the person / the habit / the dream?",
      "What can I give myself from this — without going back?"
    ],
      [
      "Writing\nWhat do I miss: the person / the habit / the dream?",
      "What can I give myself from this — without going back?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Longing points to a need, not a direction."
    ],
      [
      "Closing",
      "Longing points to a need, not a direction."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Clean exposure (gentle ACT)",
    opening: localizedGenderNode(
      [
      "To carry longing without running away."
    ],
      [
      "To carry longing without running away."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nI choose one moment today to allow longing to be here for one minute, without action.\nWhat happened?",
      "What did I learn about myself from that minute?"
    ],
      [
      "Writing\nI choose one moment today to allow longing to be here for one minute, without action.\nWhat happened?",
      "What did I learn about myself from that minute?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I am strong not because I escaped — but because I stayed."
    ],
      [
      "Closing",
      "I am strong not because I escaped — but because I stayed."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Soft boundaries",
    opening: localizedGenderNode(
      [
      "One boundary that protects me."
    ],
      [
      "One boundary that protects me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "I ask myself:\nWhat action increases the longing?",
      "I ask myself:\nWhat small boundary am I willing to set today?"
    ],
      [
      "I ask myself:\nWhat action increases the longing?",
      "I ask myself:\nWhat small boundary am I willing to set today?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A boundary is protection, not punishment."
    ],
      [
      "Closing",
      "A boundary is protection, not punishment."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "If they move on",
    opening: localizedGenderNode(
      [
      "My worth is not tied to anyone’s pace."
    ],
      [
      "My worth is not tied to anyone’s pace."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat does this image do to my body?",
      "What new truth do I choose about my worth?"
    ],
      [
      "Writing\nWhat does this image do to my body?",
      "What new truth do I choose about my worth?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I stay with myself — and that is enough."
    ],
      [
      "Closing",
      "I stay with myself — and that is enough."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "The body and longing",
    opening: localizedGenderNode(
      [
      "The body holds the story."
    ],
      [
      "The body holds the story."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhere is my body tense today?",
      "What is it asking from me?"
    ],
      [
      "Writing\nWhere is my body tense today?",
      "What is it asking from me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "When I calm the body — the heart can breathe."
    ],
      [
      "Closing",
      "When I calm the body — the heart can breathe."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Regaining control",
    opening: localizedGenderNode(
      [
      "One step."
    ],
      [
      "One step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat is in my control today? (three small things)",
      "Which one step do I take?"
    ],
      [
      "Writing\nWhat is in my control today? (three small things)",
      "Which one step do I take?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing"
    ],
      [
      "Closing"
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Nighttime",
    opening: localizedGenderNode(
      [
      "To stop loops."
    ],
      [
      "To stop loops."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat is my nighttime loop?",
      "Which closing sentence for the night do I choose?"
    ],
      [
      "Writing\nWhat is my nighttime loop?",
      "Which closing sentence for the night do I choose?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Tonight, I rest."
    ],
      [
      "Closing",
      "Tonight, I rest."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Anger",
    opening: localizedGenderNode(
      [
      "Anger without destruction."
    ],
      [
      "Anger without destruction."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Writing\nWhat is my anger protecting me from?",
      "How do I let it out without harm?"
    ],
      [
      "Writing\nWhat is my anger protecting me from?",
      "How do I let it out without harm?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Anger can become an organizing force."
    ],
      [
      "Closing",
      "Anger can become an organizing force."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Release and closing ritual",
    opening: localizedGenderNode(
      [
      "To close a chapter without erasing it."
    ],
      [
      "To close a chapter without erasing it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ],
      [
      "I pause for a moment with myself.",
      "A slow inhale… a slow exhale…",
      "One more.",
      "I feel my body here, now.",
      "I don’t have to solve anything right now — just be."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "I ask myself:\nWhat changed in me on this journey?",
      "I ask myself:\nWhat is my “path sentence” for hard days?"
    ],
      [
      "I ask myself:\nWhat changed in me on this journey?",
      "I ask myself:\nWhat is my “path sentence” for hard days?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closing for the journey",
      "I don’t erase longing —",
      "I stop letting it run my life.",
      "I keep walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ],
      [
      "Final closing for the journey",
      "I don’t erase longing —",
      "I stop letting it run my life.",
      "I keep walking —",
      "slowly, quietly, with myself.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "---",
      "---"
    ),
  },
].map(buildNormalizedDay);

export const obsessiveLongingBlueprintEn = buildNormalizedPilotBlueprint({
  id: "obsessive_longing_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "obsessive_longing",
  category: "general",
  journeyName: {
    he: "",
    en: "Obsessive longing that won’t let go",
    es: "",
  },
  days,
});

export default obsessiveLongingBlueprintEn;
